<template>
  <v-navigation-drawer
    app
    floating
    v-model="drawerModel"
    clipped
    v-if="usuarioLogado"
  >
    <UsuarioLogado />
    <v-divider></v-divider>

    <v-list v-if="atalhos.length > 0" two-line>
      <div v-for="(menu, i) in atalhos.filter((a) => a.exibir && a.nivel == 1)" :key="i">
        <template v-if="atalhos.filter((a) => a.nivel == 2 && a.mod_pai == menu.descricao).length == 0">
          <v-list-item
            link
            :to="{ path: menu.link }"
            active-class="colormenuselect font-weight-bold"
            style="min-height: 56px"
          >
            <v-list-item-action>
              <v-icon size="25" color="primary">{{ menu.icone }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="primary--text subtitle-1">{{
                menu.descricao
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-group active-class="font-weight-bold">
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon size="25" color="primary">{{ menu.icone }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text subtitle-1">{{
                  menu.descricao
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(item, i) in atalhos.filter((a) => a.nivel == 2 && a.mod_pai == menu.descricao)"
              :key="i"
              link
              :to="{ path: item.link }"
              active-class="font-weight-bold"
              style="min-height: 50px !important"
            >
              <v-list-item-action> </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text wrap-text subtitle-2">{{
                  item.descricao
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import UsuarioLogado from "../components/usuario/UsuarioLogado.vue";
import { mapMutations, mapState } from "vuex";
export default {
  name: "MenuTemplate",
  components: {
    UsuarioLogado,
  },
  computed: {
    ...mapState("sistema", ["drawer", "atalhos"]),
    ...mapState("usuario", ["usuarioLogado"]),
    drawerModel: {
      get: function () {
        return this.drawer;
      },
      set: function (value) {
        this.setDrawer(value);
      },
    },
  },
  watch: {
    atalhos: function (value) {
      if (value.findIndex((a) => a.operacao == 2681) >= 0) {
        this.menus.find((m) => m.link == "/formacao-carga").visible = true;
      }
      if (value.findIndex((a) => a.operacao == 2684) >= 0) {
        this.menus.find((m) => m.link == "/visita-tecnica").visible = true;

        if(!this.usuarioLogado.supervisor){
          this.menus.filter((m) => m.link != "/visita-tecnica").forEach((men) => {
            men.visible = false
          })
        }
      }
    },
  },
  data: () => ({
    menus: [
      {
        descricao: "Cadastros",
        icone: "mdi-account-multiple-plus-outline",
        submenus: [{ descricao: "Clientes", link: "/clientes" }],
        visible: true,
      },
      {
        descricao: "Pedidos",
        icone: "mdi-cart-arrow-down",
        submenus: [
          {
            descricao: "Central de pedidos",
            link: "/selecionar-tipo-pedido/pedidos",
          },
          {
            descricao: "Emissão de pedidos",
            link: "/selecionar-tipo-pedido/emissao",
          },
        ],
        visible: true,
      },
      {
        descricao: "Formação de Carga",
        icone: "mdi-truck-outline",
        link: "/formacao-carga",
        submenus: [],
        visible: false,
      },
      {
        descricao: "Visita Técnica",
        icone: "mdi-cow",
        link: "/visita-tecnica",
        submenus: [],
        visible: false,
      },
      {
        descricao: "Relatórios",
        icone: "mdi-chart-line",
        link: "/relatorios",
        submenus: [],
        visible: true,
      },
    ],
  }),
  methods: {
    ...mapMutations("sistema", ["setDrawer"]),
  },   
};
</script>

<style>
.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 58px;
}
</style>